import type { RootState, UserState, User } from "@/types";
import type { GetterTree } from "vuex";

export const getters: GetterTree<UserState, RootState> = {
  checkGlobalPermission: (state) => (permissionLabel: string) => {
    const user = state.user.data;

    return user.permissions
      ? user.permissions.filter(
          (permission: any) => permission.name === permissionLabel,
        ).length > 0
      : false;
  },
  getCurrentUserData(state): User {
    return state.user.data;
  },
  getCurrentUserIsExternal(state): User {
    return state.user.data.isExternal;
  },
  getCurrentUserLoading(state): boolean {
    return state.user.loading;
  },
  getCurrentUserError(state): string | null {
    return state.user.error;
  },
  activeFavoritesProjects(state): boolean {
    const user = state.user.data;
    return (
      (user && user.preferences && user.preferences.showFavoritesProject) ||
      false
    );
  },
  favoritesProjects(state): string[] {
    const user = state.user.data;
    return user && user.favoriteProjects && user.favoriteProjects.length
      ? [...user.favoriteProjects].map((favoriteProject: any) => {
          return favoriteProject.id;
        })
      : [];
  },

  favoritesPlaces(state): string[] {
    const user = state.user.data;
    return user && user.favoriteProjects && user.favoriteProjects.length
      ? Array.from(
          new Set(
            [...user.favoriteProjects].map((favoriteProject: any) => {
              return favoriteProject.place.id;
            }),
          ),
        )
      : [];
  },
};
